import React, { useState } from "react";
import "../css/CBSESection.css";
import SchoolHero from "../components/SchoolLevels/SchoolHero";


const STAGES = [
  {
    code: "01",
    name: "Early Childhood Education (ECCD)",
    classes: "Play Group – UKG",
    age: "Age 3 – 5 Years",
    desc:
      "Our Early Childhood programme provides a joyful, play-based learning environment where children develop language, communication, creativity, social confidence, and foundational literacy and numeracy through hands-on activities and exploration.",
  },

  {
    code: "02",
    name: "Primary Level",
    classes: "Grade 1 – Grade 5",
    age: "Age 6 – 10 Years",
    desc:
      "Students build strong academic foundations in English, Nepali, Mathematics, Science, Social Studies, Computer Education and Creative Arts through activity-based and student-centred learning approaches.",
  },

  {
    code: "03",
    name: "Lower Secondary",
    classes: "Grade 6 – Grade 8",
    age: "Age 11 – 13 Years",
    desc:
      "Learners strengthen conceptual understanding, critical thinking, collaboration and practical application through projects, laboratories, presentations and technology-integrated classrooms.",
  },

  {
    code: "04",
    name: "Secondary Level (SEE)",
    classes: "Grade 9 – Grade 10",
    age: "Age 14 – 16 Years",
    desc:
      "Students follow Nepal's National Curriculum while preparing for the SEE examination through academic excellence and practical learning.",
  },

  {
    code: "05",
    name: "Higher Secondary (NEB)",
    classes: "Grade 11 – Grade 12",
    age: "Age 16 – 18 Years",
    desc:
      "Students choose specialised streams under NEB while preparing for university education and professional careers.",
  },
];

const STREAMS = [
  {
    name: "Science",
    subjects: [
      "Physics",
      "Chemistry",
      "Biology / Mathematics",
      "English",
      "Computer Science",
    ],
  },

  {
    name: "Management",
    subjects: [
      "Accountancy",
      "Economics",
      "Business Studies",
      "English",
      "Computer Applications",
    ],
  },

  {
    name: "Humanities",
    subjects: [
      "History",
      "Political Science",
      "Sociology",
      "Economics",
      "English",
    ],
  },
];

const PILLARS = [
  {
    title: "Academic Excellence",
    detail:
      "Strong academic foundations supported by qualified teachers and modern learning practices.",
  },

  {
    title: "Holistic Development",
    detail:
      "Sports, arts, leadership, communication and life skills are equally important.",
  },

  {
    title: "Future Ready Learning",
    detail:
      "Technology, STEM, coding and project-based learning prepare students for tomorrow.",
  },
];
export default function CBSESection() {
  const [activeStage, setActiveStage] = useState(0);
  return (
<>
         <SchoolHero
        title="SEEB NEPAL"
        subtitle="World-Class Infrastructure"
         image="./images/high.jpg"
      />
    <section className="cbse-section">


      <div className="cbse-container">

        <header className="cbse-header">


          <span className="cbse-eyebrow">

            Sahara Public Secondary School • Nepal

          </span>



          <h1 className="cbse-title">

            Nepal National Curriculum

            <br />

            (SEE & NEB)

          </h1>



          <p className="cbse-lede">

            Sahara Public Secondary School follows Nepal's
            National Curriculum Framework from Early Childhood
            Education through Grade 12, preparing students for
            SEE and NEB examinations while promoting leadership,
            innovation, values and lifelong learning.

          </p>


        </header>





        {/* ================= CURRICULUM OVERVIEW ================= */}


        <section className="curriculum-overview">


          <div className="overview-left">


            <span className="overview-tag">

              About Our Curriculum

            </span>



            <h2>

              Learning Beyond

              <br />

              The Classroom

            </h2>




            <p>

              Education at Sahara Public Secondary School
              extends beyond textbooks. We believe every
              learner possesses unique abilities, talents
              and aspirations that deserve to be nurtured
              through experiential learning.

            </p>




            <p>

              Students participate in collaborative projects,
              laboratory work, digital learning, leadership
              programmes, sports, performing arts,
              community engagement and innovation challenges.

            </p>




            <p>

              Our curriculum combines Nepal's National
              Curriculum Framework with modern teaching
              methodologies to develop confident,
              responsible, ethical and globally competent
              learners.

            </p>



          </div>





          <div className="overview-right">


            <img

              src="./images/kk.jpeg"

              alt="Students Learning"

            />


          </div>



        </section>






        {/* ================= EDUCATION STAGES ================= */}



        <section className="education-stage-section">



          <div className="cbse-ladder">


            {STAGES.map((stage,index)=>(


              <button

                key={stage.code}

                className={`cbse-rung ${
                  activeStage === index
                    ? "is-active"
                    : ""
                }`}


                onClick={() =>
                  setActiveStage(index)
                }


              >



                <span className="cbse-rung-code">

                  {stage.code}

                </span>




                <span className="cbse-rung-name">

                  {stage.name}

                </span>




                <span className="cbse-rung-classes">

                  {stage.classes}

                </span>



              </button>



            ))}



          </div>






          <div className="cbse-stage-detail">


            <div className="cbse-stage-meta">


              <span className="cbse-stage-age">

                {STAGES[activeStage].age}

              </span>




              <h2 className="cbse-stage-name">

                {STAGES[activeStage].name}

              </h2>



            </div>




            <p className="cbse-stage-desc">

              {STAGES[activeStage].desc}

            </p>



          </div>



        </section>







        {/* ================= NEB STREAMS ================= */}



        <section className="cbse-streams-block">


          <div className="section-heading">


            <span>

              Higher Secondary Education

            </span>




            <h2>

              Streams Offered at Grade 11 & 12

            </h2>




            <p>

              After completing SEE, students can choose
              Science, Management or Humanities according
              to their interests and future career goals.

            </p>



          </div>





          <div className="cbse-streams-grid">


            {STREAMS.map((stream)=>(



              <article

                className="cbse-stream-card"

                key={stream.name}

              >



                <h3 className="cbse-stream-name">

                  {stream.name}

                </h3>





                <ul className="cbse-stream-list">


                  {stream.subjects.map((subject)=>(


                    <li key={subject}>

                      {subject}

                    </li>



                  ))}



                </ul>




              </article>



            ))}



          </div>



        </section>
        {/* ================= WHY SAHARA ================= */}


        <section className="why-sahara">


          <div className="why-image">


            <img

              src="./images/m.jpeg"

              alt="School Campus"

            />


          </div>





          <div className="why-content">


            <span className="overview-tag">

              Why Choose Sahara?

            </span>




            <h2>

              A Complete Learning

              <br />

              Environment

            </h2>




            <p>

              We combine Nepal's National Curriculum with
              innovative teaching, smart classrooms,
              laboratories, sports and leadership
              opportunities to create confident learners.

            </p>





            <div className="why-list">


              <div className="why-item">

                ✔ Experienced Teachers

              </div>



              <div className="why-item">

                ✔ Smart Digital Classrooms

              </div>




              <div className="why-item">

                ✔ Science & Computer Labs

              </div>




              <div className="why-item">

                ✔ Sports & Physical Education

              </div>




              <div className="why-item">

                ✔ Leadership Development

              </div>




              <div className="why-item">

                ✔ Safe Campus

              </div>



            </div>



          </div>



        </section>







        {/* ================= LEARNING PILLARS ================= */}



        <section className="cbse-pillars">



          {PILLARS.map((pillar)=>(



            <div

              className="cbse-pillar"

              key={pillar.title}

            >



              <h3 className="cbse-pillar-title">

                {pillar.title}

              </h3>





              <p className="cbse-pillar-detail">

                {pillar.detail}

              </p>



            </div>



          ))}



        </section>







        {/* ================= ASSESSMENT ================= */}



        <section className="assessment-section">


          <div className="assessment-left">


            <span className="overview-tag">

              Assessment System

            </span>





            <h2>

              Continuous &

              <br />

              Comprehensive Evaluation

            </h2>





            <p>

              Students are assessed through classroom
              participation, assignments, practical work,
              presentations, projects, unit tests and
              final examinations.

            </p>





            <p>

              This approach develops critical thinking,
              creativity, communication and conceptual
              understanding instead of only examination
              performance.

            </p>



          </div>






          <div className="assessment-right">


            <img

              src="./images/c.jpeg"

              alt="Assessment"

            />


          </div>



        </section>







        {/* ================= CTA ================= */}



        <section className="cbse-cta">


          <h2>

            Begin Your Child's Learning Journey

          </h2>





          <p>

            Join Sahara Public Secondary School and
            experience Nepal's National Curriculum with
            world-class learning opportunities,
            experienced teachers and holistic education.

          </p>





          <div className="cta-buttons">


            <a

              href="/admission"

              className="cbse-cta-button"

            >

              Apply for Admission

            </a>





            <a

              href="/contact"

              className="cbse-cta-outline"

            >

              Contact Us

            </a>



          </div>



        </section>





      </div>


    </section>

</>
  );


}